// extracted by mini-css-extract-plugin
export var container = "_45-0";
export var icon = "_45-1";
export var text = "_45-2";